import React from 'react';
import PropTypes from 'prop-types';
import { createIntl, createIntlCache, FormattedMessage, defineMessages } from 'react-intl';
import Select from 'react-select';

import Config from '../../utils/config';
import { getCurrentTranslation } from '../../utils/translations.js';

const messages = defineMessages({
    filter_activity_choose_type: { id: 'filter_activity_choose_type', defaultMessage: 'Zvolte typ cvičení' },
    filter_activity_item_all_label: { id: 'filter_activity_item_all_label', defaultMessage: 'Všechny druhy' },
    filter_activity_item_revise_label: { id: 'filter_activity_item_revise_label', defaultMessage: 'Zopakuj si' },
    filter_activity_item_revise_under: { id: 'filter_activity_item_revise_under', defaultMessage: 'Videa, obrázky, poslechy' },
    filter_activity_item_exercise_label: { id: 'filter_activity_item_exercise_label', defaultMessage: 'Procvičuj' },
    filter_activity_item_exercise_under: { id: 'filter_activity_item_exercise_under', defaultMessage: 'Interaktivní cvičení' },
    filter_activity_item_verify_label: { id: 'filter_activity_item_verify_label', defaultMessage: 'Ověř si' },
    filter_activity_item_verify_under: { id: 'filter_activity_item_verify_under', defaultMessage: 'Interaktivní testy' },
    filter_activity_item_involve_parents_label: { id: 'filter_activity_item_involve_parents_label', defaultMessage: 'Zapoj rodiče' },
    filter_activity_item_involve_parents_under: { id: 'filter_activity_item_involve_parents_under', defaultMessage: 'Interaktivní testy' },
    filter_activity_item_involve_use_book_label: { id: 'filter_activity_item_involve_use_book_label', defaultMessage: 'Použij knihu' },
    filter_activity_item_involve_use_book_under: { id: 'filter_activity_item_involve_use_book_under', defaultMessage: 'Doplňky k tištěným titulům' },
});

var cache;
var intl;

const Option = props => {

    const { data, innerProps, innerRef } = props;

    if (data.value === '') {
        return (
            <div className={'intent-option-first ' + data.value} ref={innerRef} {...innerProps}>
                <div className='label'>{data.label}</div>
            </div>
        );
    }

    return (
        <div className={'intent-option ' + data.value} ref={innerRef} {...innerProps}>
            <div className='label'>{data.label}</div>
            <div className="under">{data.under}</div>
        </div>
    );
};

class IntentSelect extends React.Component {

    constructor(props) {
        super(props);

        cache = createIntlCache();
        intl = createIntl({ locale: Config.get('locale'), messages: getCurrentTranslation(Config.get('locale')) }, cache);

        this.onChange = this.onChange.bind(this);

        const _f = describer => {
            return intl.formatMessage(describer);
        };

        this.optionsAll = [
            { value: '', label: _f(messages.filter_activity_item_all_label), under: '' },
            { value: 'revise', label: _f(messages.filter_activity_item_revise_label), under: _f(messages.filter_activity_item_revise_under) },
            { value: 'exercise', label: _f(messages.filter_activity_item_exercise_label), under: _f(messages.filter_activity_item_exercise_under) },
            { value: 'verify', label: _f(messages.filter_activity_item_verify_label), under: _f(messages.filter_activity_item_verify_under) },
            { value: 'involve_parents', label: _f(messages.filter_activity_item_involve_parents_label), under: _f(messages.filter_activity_item_involve_parents_under) },
            { value: 'use_book', label: _f(messages.filter_activity_item_involve_use_book_label), under: _f(messages.filter_activity_item_involve_use_book_under) },
        ];
    }

    getOptions(activityIntents) {
        const options = [];

        options.push(this.optionsAll[0]);

        activityIntents.forEach((activityIntent) => {
            this.optionsAll.forEach((option) => {
                if (option.value === activityIntent) {
                    options.push(option);
                }
            });
        });

        return options;
    }

    onChange(selectedOption) {
        const { choiceCallback } = this.props;

        this.setState({ selectedOption });
        choiceCallback(selectedOption.value);
    }

    findOptionByValue(optionValue) {
        for (let i = 0; i < this.optionsAll.length; i++) {
            const option = this.optionsAll[i];

            if (option.value === optionValue) {
                return option;
            }
        }

        return null;
    }

    render() {
        const { activityIntents, selectedIntent } = this.props;

        const options = this.getOptions(activityIntents);
        const placeholder = intl.formatMessage(messages.filter_activity_choose_type);

        return (
            options.length > 1 &&
            <div className='intent-filter'>
                <div className='intent-filter__label'>
                    <FormattedMessage
                        id='filter_activity_title'
                        defaultMessage='Typy{nbsp}aktivit:'
                        values={{ nbsp: <React.Fragment>&nbsp;</React.Fragment> }}
                    />
                </div>
                <Select
                    className='intent-options'
                    classNamePrefix='intent-options'
                    isSearchable={false}
                    placeholder={placeholder}
                    components={
                        {
                            Option,
                            IndicatorSeparator: null,
                        }
                    }
                    value={this.findOptionByValue(selectedIntent)}
                    options={options}
                    onChange={this.onChange}
                />
            </div>
        )
    }
}

IntentSelect.propTypes = {
    choiceCallback: PropTypes.func.isRequired,
    activityIntents: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedIntent: PropTypes.string.isRequired
};

export default IntentSelect;
